import React, { useEffect } from 'react';
import style from './ConfirmModal.module.css';

/**
 * 확인/취소 버튼이 있는 공통 모달
 *
 * @param {boolean}    open         모달 표시 여부
 * @param {string}     title        제목
 * @param {string|React.ReactNode} message 본문
 * @param {string}     confirmText  확인 버튼 텍스트 (default '확인')
 * @param {string}     cancelText   취소 버튼 텍스트 (default '취소')
 * @param {() => void} onConfirm    확인 콜백
 * @param {() => void} onCancel     취소 콜백 (딤 클릭 / ESC 포함)
 * @param {'primary'|'danger'} confirmType 확인 버튼 색상 (default 'primary')
 */
const ConfirmModal = ({
    open,
    title,
    message,
    confirmText = '확인',
    cancelText  = '취소',
    onConfirm,
    onCancel,
    confirmType = 'primary',
}) => {
    // ESC 키로 닫기
    useEffect(() => {
        if (!open) return;
        const handleKey = (e) => {
            if (e.key === 'Escape') onCancel?.();
        };
        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [open, onCancel]);

    // body 스크롤 잠금
    useEffect(() => {
        if (!open) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = prev; };
    }, [open]);

    if (!open) return null;

    return (
        <div
            className={style.dim}
            onClick={onCancel}
            role="dialog"
            aria-modal="true"
            aria-labelledby="confirm-modal-title"
        >
            <div
                className={style.modal}
                onClick={(e) => e.stopPropagation()}
            >
                <h3 id="confirm-modal-title" className={style.title}>{title}</h3>
                <div className={style.message}>{message}</div>
                <div className={style.btnGroup}>
                    <button
                        type="button"
                        className={`${style.btn} ${style.btnCancel}`}
                        onClick={onCancel}
                    >
                        {cancelText}
                    </button>
                    <button
                        type="button"
                        className={`${style.btn} ${confirmType === 'danger' ? style.btnDanger : style.btnPrimary}`}
                        onClick={onConfirm}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;